export enum IJoistProfileType {
  IJ_9_5_2X3 = "IJ_9_5_2X3",
  IJ_11_875_2X3 = "IJ_11_875_2X3",
  IJ_11_875_2X4 = "IJ_11_875_2X4",
  IJ_14_2X3 = "IJ_14_2X3",
  IJ_14_2X4 = "IJ_14_2X4",
  IJ_16_2X3 = "IJ_16_2X3",
  IJ_16_2X4 = "IJ_16_2X4",
  IJ_18_2X4 = "IJ_18_2X4",
  IJ_20_2X4 = "IJ_20_2X4",
}

// "IJoist" is a structural-product proper noun (engineered wood I-joist), not an
// interface-prefix Hungarian notation, so the `^I[A-Z]` interface-name guard does
// not apply meaningfully here.
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IJoistProfileDescriptor {
  readonly type: IJoistProfileType;
  readonly name: string;
  readonly depth: number;
  readonly flangeWidth: number;
  readonly flangeThickness: number;
  readonly webThickness: number;
  readonly annotationLabel: string;
}

export const IJoistProfileTypeToName: { [key in IJoistProfileType]: string } = {
  [IJoistProfileType.IJ_9_5_2X3]: 'I-Joist 9 1/2" / 2x3',
  [IJoistProfileType.IJ_11_875_2X3]: 'I-Joist 11 7/8" / 2x3',
  [IJoistProfileType.IJ_11_875_2X4]: 'I-Joist 11 7/8" / 2x4',
  [IJoistProfileType.IJ_14_2X3]: 'I-Joist 14" / 2x3',
  [IJoistProfileType.IJ_14_2X4]: 'I-Joist 14" / 2x4',
  [IJoistProfileType.IJ_16_2X3]: 'I-Joist 16" / 2x3',
  [IJoistProfileType.IJ_16_2X4]: 'I-Joist 16" / 2x4',
  [IJoistProfileType.IJ_18_2X4]: 'I-Joist 18" / 2x4',
  [IJoistProfileType.IJ_20_2X4]: 'I-Joist 20" / 2x4',
};

export function iJoistProfileDescriptorNew(
  type: IJoistProfileType,
  name: string,
  depth: number,
  flangeWidth: number,
  flangeThickness: number,
  webThickness: number,
  annotationLabel: string = name,
): IJoistProfileDescriptor {
  return {
    type,
    name,
    depth,
    flangeWidth,
    flangeThickness,
    webThickness,
    annotationLabel,
  };
}

export const IJoistProfileCatalog: { [key in IJoistProfileType]: IJoistProfileDescriptor } = {
  IJ_9_5_2X3: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_9_5_2X3,
    IJoistProfileTypeToName[IJoistProfileType.IJ_9_5_2X3],
    9.5,
    2.5,
    1.5,
    3 / 8,
  ),
  IJ_11_875_2X3: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_11_875_2X3,
    IJoistProfileTypeToName[IJoistProfileType.IJ_11_875_2X3],
    11.875,
    2.5,
    1.5,
    3 / 8,
  ),
  IJ_11_875_2X4: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_11_875_2X4,
    IJoistProfileTypeToName[IJoistProfileType.IJ_11_875_2X4],
    11.875,
    3.5,
    1.5,
    3 / 8,
  ),
  IJ_14_2X3: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_14_2X3,
    IJoistProfileTypeToName[IJoistProfileType.IJ_14_2X3],
    14,
    2.5,
    1.5,
    3 / 8,
  ),
  IJ_14_2X4: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_14_2X4,
    IJoistProfileTypeToName[IJoistProfileType.IJ_14_2X4],
    14,
    3.5,
    1.5,
    3 / 8,
  ),
  IJ_16_2X3: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_16_2X3,
    IJoistProfileTypeToName[IJoistProfileType.IJ_16_2X3],
    16,
    2.5,
    1.5,
    3 / 8,
  ),
  IJ_16_2X4: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_16_2X4,
    IJoistProfileTypeToName[IJoistProfileType.IJ_16_2X4],
    16,
    3.5,
    1.5,
    3 / 8,
  ),
  IJ_18_2X4: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_18_2X4,
    IJoistProfileTypeToName[IJoistProfileType.IJ_18_2X4],
    18,
    3.5,
    1.5,
    7 / 16,
  ),
  IJ_20_2X4: iJoistProfileDescriptorNew(
    IJoistProfileType.IJ_20_2X4,
    IJoistProfileTypeToName[IJoistProfileType.IJ_20_2X4],
    20,
    3.5,
    1.5,
    7 / 16,
  ),
};
